"use strict";

// Helper functions for consent management
function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

// Function to set gtag consent based on the CookieConsent cookie
function setGtagConsentFromCookie() {
  let cookieConsent = getCookie("CookieConsent");
  if (cookieConsent) {
    try {
      let consent = JSON.parse(decodeURIComponent(cookieConsent));
      typeof gtag === "function" && gtag("consent", "update", {
        ad_storage: consent.marketing ? "granted" : "denied",
        ad_user_data: consent.marketing ? "granted" : "denied",
        ad_personalization: consent.marketing ? "granted" : "denied",
        analytics_storage: consent.statistics ? "granted" : "denied"
      });
    } catch (e) {
      console.error("Error parsing CookieConsent cookie: ", e);
    }
  } else {
    // Set default consent to 'denied' if the cookie is not found
    typeof gtag === "function" && gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied"
    });
    window.showCookieBanner = true;
  }
}
const consentGranted = parameter => {
  typeof gtag === "function" && gtag("consent", "update", {
    [parameter]: "granted"
  });
};
const consentDenied = parameter => {
  typeof gtag === "function" && gtag("consent", "update", {
    [parameter]: "denied"
  });
};

// Function to set the preference cookie
const setPreferenceCookie = (preferences, statistics, marketing) => {
  const consentData = JSON.stringify({
    necessary: true,
    preferences,
    statistics,
    marketing,
    timestamp: Date.now(),
    ver: 1
  });
  const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = "CookieConsent=".concat(consentData, "; expires=").concat(expires, "; path=/");
};

// Function to toggle cookie consent box visibility
const setCookieboxVisible = visible => {
  const cookieConsentBox = document.querySelector("#cookieConsentBox");
  if (!cookieConsentBox) {
    console.error("Couldn't find cookie consent box");
    return;
  }
  cookieConsentBox.classList.toggle("not-visible", !visible);
};

// Function to switch tabs in the cookie consent box
const switchTab = tabName => {
  const cookieConsentBox = document.querySelector("#cookieConsentBox");
  if (!cookieConsentBox) {
    console.error("Couldn't find cookie consent box");
    return;
  }
  const tabs = cookieConsentBox.querySelectorAll(".tabs > a");
  if (!tabs.length) {
    console.error("Couldn't find cookie consent tabs");
    return;
  }
  tabs.forEach(tab => {
    tab.setAttribute("aria-selected", tab.dataset.target === tabName ? "true" : "false");
  });
  const tabBodies = cookieConsentBox.querySelectorAll("div[data-target]");
  if (!tabBodies.length) {
    console.error("Couldn't find cookie consent tab bodies");
    return;
  }
  tabBodies.forEach(tabBody => {
    tabBody.classList.toggle("hidden", tabBody.dataset.target !== tabName);
    tabBody.classList.toggle("flex", tabBody.dataset.target == tabName);
  });
};

// Initialize cookie consent box functionality
(() => {
  setGtagConsentFromCookie();
  const cookieConsentBox = document.querySelector("#cookieConsentBox");
  if (!cookieConsentBox) {
    console.error("Couldn't find cookie consent box");
    return;
  }
  const tabs = cookieConsentBox.querySelectorAll(".tabs > a");
  if (!tabs.length) {
    console.error("Couldn't find cookie consent tabs");
    return;
  }
  tabs.forEach(tab => {
    tab.addEventListener("click", e => {
      e.preventDefault();
      switchTab(tab.dataset.target);
    });
  });
  cookieConsentBox.querySelectorAll(".detail-btn").forEach(detailExpander => {
    detailExpander.addEventListener("click", e => {
      e.preventDefault();
      const bodyTarget = cookieConsentBox.querySelector("#" + detailExpander.getAttribute("data-target"));
      if (!bodyTarget) {
        console.error("Couldn't find detailExpander: ".concat(detailExpander.getAttribute("data-target")));
        return;
      }
      bodyTarget.classList.toggle("hidden");
      bodyTarget.classList.toggle("flex");
    });
  });
  const buttonsContainer = cookieConsentBox.querySelector(".cookie-buttons");
  if (!buttonsContainer) {
    console.error("Couldn't find cookie button container");
    return;
  }
  const allowPreferences = cookieConsentBox.querySelector("#allowPreferences");
  const allowStatistics = cookieConsentBox.querySelector("#allowStatistics");
  const allowMarketing = cookieConsentBox.querySelector("#allowMarketing");
  const allowNecessaryButton = buttonsContainer.querySelector("#allowNecessaryButton");
  const allowSelectedButton = buttonsContainer.querySelector("#allowSelectedButton");
  const allowAllButton = buttonsContainer.querySelector("#allowAllButton");
  const handleConsent = (preferences, statistics, marketing) => {
    window.consent = {
      allowPreferences: preferences,
      allowStatistics: statistics,
      allowMarketing: marketing
    };
    allowPreferences.checked = preferences;
    allowStatistics.checked = statistics;
    allowMarketing.checked = marketing;
    statistics ? consentGranted("analytics_storage") : consentDenied("analytics_storage");
    marketing ? consentGranted("ad_storage") : consentDenied("ad_storage");
    marketing ? consentGranted("ad_user_data") : consentDenied("ad_user_data");
    marketing ? consentGranted("ad_personalization") : consentDenied("ad_personalization");
    const map = document.querySelector(".map");
    if (map) {
      map.classList.toggle("allowed", marketing);
      if (map.classList.contains("allowed") && isElementInViewport(map)) {
        loadMap(map.querySelector("iframe"));
      }
    }
    if (statistics) {
      if (typeof Bugsnag !== "undefined") {
        Bugsnag.startSession();
        Bugsnag.leaveBreadcrumb("User consented to tracking (statistics)", {
          type: "state"
        });
      }
    } else {
      window.settings.bugsnagOptions = {
        autoTrackSessions: false,
        collectUserIp: false,
        generateAnonymousId: false,
        enabledBreadcrumbTypes: ["error", "manual"]
      };
    }
    setPreferenceCookie(preferences, statistics, marketing);
    setCookieboxVisible(false);
  };
  allowNecessaryButton.addEventListener("click", () => {
    handleConsent(false, false, false);
  });
  allowSelectedButton.addEventListener("click", () => {
    handleConsent(allowPreferences.checked, allowStatistics.checked, allowMarketing.checked);
  });
  allowAllButton.addEventListener("click", () => {
    handleConsent(true, true, true);
  });
  buttonsContainer.querySelectorAll("button").forEach(button => {
    button.disabled = false;
  });
  if (window.showCookieBanner !== undefined && window.showCookieBanner == true) {
    setCookieboxVisible(true);
  }
})();
//# sourceMappingURL=cookies.js.map